import React from 'react';
import logo from '../logo.svg';
import '../App.css';
import { Link, NavLink } from "react-router-dom";
import { MassCommunicationList } from "../screens/mass_communications.js";

const Divider = () => {
    return(
        <hr  style={{
            marginLeft  :20,
            marginRight :20,
            borderColor : '#fff'
        }}/>
    );
}

const Footer = () => {
    return(
        <>
        <footer className="sticky-footer bg-white d-print-none">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>Powerd By <a href="https://technimitta.com/" target="_blank">Nimitta Technologies</a></span>
                </div>
            </div>
        </footer>
        </>
    );
}

function toggle(event) {
  var El = event.target;
  El.addEventListener("click",()=>{
    const sidebar = document.getElementsByClassName("sidebar")[0];
    document.body.classList.toggle("sidebar-toggled");
    sidebar.classList.toggle("toggled");

    if(sidebar.classList.contains("toggled")) {
      //sidebar.getElementsByClassName("collapse")[0].collapse('hide');
    }
  });
}

function SideNav() {
    return(
        <>
        <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion d-print-none" id="accordionSidebar">

            <Link to="/" className="sidebar-brand d-flex align-items-center justify-content-center" href="#">
                <div className="sidebar-brand-icon">
                    {/*<img src="/img/logo.jpg" className="img img-fluid"></img>*/}
                    <div className="sidebar-brand-text">WHISPERING OAKS ESTATES</div>
                </div>
            </Link>

            <li className="nav-item">
                <NavLink name="dashboard" className="nav-link" to="/">
                    <i className="fas fa-fw fa-tachometer-alt"></i>
                    <span>Dashboard</span>
                </NavLink>
            </li>

            <Divider />

            <li className="nav-item">
                <NavLink className="nav-link" to="/albums">
                    <i className="fas fa-images"></i>
                    <span>Albums</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink name="events" className="nav-link" to="/events">
                    <i className="far fa-calendar-alt"></i>
                    <span>Events</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink name="mom" className="nav-link" to="/mom">
                    <i className="far fa-calendar"></i>
                    <span>Meeting Minutes</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink name="newsletters" className="nav-link" to="/newsletters">
                    <i className="far fa-newspaper"></i>
                    <span>Newsletter</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink name="treasurer_reports" className="nav-link" to="/treasurer_reports">
                    <i className="far fa-newspaper"></i>
                    <span>Treasurer Reports</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/complaints">
                    <i className="fas fa-list"></i>
                    <span>My Complaints</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/violations">
                    <i className="fas fa-exclamation-triangle"></i>
                    <span>Violations</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/new-complaint">
                    <i className="fas fa-file-signature"></i>
                    <span>Post a Complaint</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/change-requests">
                    <i className="fas fa-list"></i>
                    <span>ACC Requests</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/acc-form">
                <i className="fas fa-file-signature"></i>
                    <span>ACC Form</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/fee">
                <i className="fas fa-file-signature"></i>
                    <span>Fees</span>
                </NavLink>
            </li>

            <Divider />
            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle" onClick={toggle}></button>
            </div>
        </ul>
        </>
    );
}

function TopBar() {
    var username = sessionStorage.getItem("userName");
    return(
        <>
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow d-print-none">

            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3" onClick={toggle}>
                <i className="fa fa-bars"></i>
            </button>

            {/*
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                <div className="input-group">
                    <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..."
                        aria-label="Search" aria-describedby="basic-addon2" />
                    <div className="input-group-append">
                        <button className="btn btn-primary" type="button">
                            <i className="fas fa-search fa-sm"></i>
                        </button>
                    </div>
                </div>
            </form>
            */}

            <ul className="navbar-nav ml-auto">
{/*
                <li className="nav-item dropdown no-arrow d-sm-none">
                    <a className="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-search fa-fw"></i>
                    </a>

                    <div className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
                        aria-labelledby="searchDropdown">
                        <form className="form-inline mr-auto w-100 navbar-search">
                            <div className="input-group">
                                <input type="text" className="form-control bg-light border-0 small"
                                    placeholder="Search for..." aria-label="Search"
                                    aria-describedby="basic-addon2" />
                                <div className="input-group-append">
                                    <button className="btn btn-primary" type="button">
                                        <i className="fas fa-search fa-sm"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </li>
*/}
 {/*
                 <li className="nav-item dropdown no-arrow mx-1">
                     <a className="nav-link dropdown-toggle" href="#" id="alertsDropdown" role="button"
                         data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                         <i className="fas fa-bell fa-fw"></i>

                         <span className="badge badge-danger badge-counter">3+</span>
                     </a>

                     <div className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                         aria-labelledby="alertsDropdown">
                         <h6 className="dropdown-header">
                             Alerts Center
                         </h6>
                         <a className="dropdown-item d-flex align-items-center" href="#">
                             <div className="mr-3">
                                 <div className="icon-circle bg-primary">
                                     <i className="fas fa-file-alt text-white"></i>
                                 </div>
                             </div>
                             <div>
                                 <div className="small text-gray-500">December 12, 2019</div>
                                 <span className="font-weight-bold">A new monthly report is ready to download!</span>
                             </div>
                         </a>
                         <a className="dropdown-item d-flex align-items-center" href="#">
                             <div className="mr-3">
                                 <div className="icon-circle bg-success">
                                     <i className="fas fa-donate text-white"></i>
                                 </div>
                             </div>
                             <div>
                                 <div className="small text-gray-500">December 7, 2019</div>
                                 $290.29 has been deposited into your account!
                             </div>
                         </a>
                         <a className="dropdown-item d-flex align-items-center" href="#">
                             <div className="mr-3">
                                 <div className="icon-circle bg-warning">
                                     <i className="fas fa-exclamation-triangle text-white"></i>
                                 </div>
                             </div>
                             <div>
                                 <div className="small text-gray-500">December 2, 2019</div>
                                 Spending Alert: We've noticed unusually high spending for your account.
                             </div>
                         </a>
                         <a className="dropdown-item text-center small text-gray-500" href="#">Show All Alerts</a>
                     </div>
                 </li>
*/}

                <li className="nav-item dropdown no-arrow mx-1">
                    <MassCommunicationList />
                </li>

                {/*<div className="topbar-divider d-none d-sm-block"></div>*/}

                <li className="nav-item dropdown no-arrow">
                    <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="mr-2 d-none d-lg-inline text-gray-600 small"> {username} </span>
                        <img className="img-profile rounded-circle"
                            src="/img/undraw_profile.svg" />
                    </a>

                    <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                        aria-labelledby="userDropdown">
                        <Link className="dropdown-item" to="/profile">
                            <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                            Profile
                        </Link>
                        {/*
                        <a className="dropdown-item" href="#">
                            <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                            Settings
                        </a>
                        <a className="dropdown-item" href="#">
                            <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                            Activity Log
                        </a>
                        */}
                        <div className="dropdown-divider"></div>
                        <a className="dropdown-item" href="/logout" data-toggle="modal" data-target="#logoutModal">
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Logout
                        </a>
                    </div>
                </li>

            </ul>
        </nav>
        </>
    );
}

export {Footer, SideNav, TopBar};
